const AnswerEvaluationReverse = {
  NA: 'na',
  TRUE: 'true',
  FALSE: 'false'
};

export { AnswerEvaluationReverse };
export default AnswerEvaluationReverse;
